import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { Plus, Minus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-navy-700" data-id="element-73">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-74">
        <span className="text-lg font-medium text-white pr-8" data-id="element-75">{question}</span>
        {isOpen ? <Minus className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-76" /> : <Plus className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-77" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-78">
        <p className="text-gray-100 leading-relaxed" data-id="element-79">{answer}</p>
      </div>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Funciona para cualquier edad de bebé?',
    a: 'Sí. El sistema está diseñado para bebés de 4 a 24 meses, con protocolos específicos por etapa. Hay tablas de ventanas de sueño desde los 4 meses hasta los 2 años.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo en tu celular o computadora en formato PDF.'
  }, {
    q: '¿Es un método de llanto controlado?',
    a: 'No. El MegaPack Noches de Paz está diseñado desde un enfoque completamente respetuoso. No usamos ni recomendamos ningún método que implique dejar llorar al bebé sin respuesta.'
  }, {
    q: '¿Qué pasa si no funciona?',
    a: 'Tenés 7 días de garantía total. Si aplicás el sistema y no ves cambios reales, te devolvemos el 100% de tu dinero sin formularios ni preguntas.'
  }, {
    q: '¿Necesito tener conocimientos previos sobre sueño infantil?',
    a: 'Para nada. El sistema está diseñado para padres sin ningún conocimiento previo. El Tomo 1 explica desde cero la biología del sueño de tu bebé en lenguaje claro y directo.'
  }, {
    q: '¿Sirve si mi bebé ya tiene más de 12 meses?',
    a: 'Sí. El Tomo 4 de Autonomía Gradual y el Manual de Crisis están específicamente pensados para bebés de 12 a 24 meses. Nunca es tarde para implementar el sistema.'
  }];
  return <section className="py-6 md:py-10 px-4 bg-navy-800/30" data-id="element-80">
      <div className="max-w-3xl mx-auto" data-id="element-81">
        <FadeIn data-id="element-82">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-white mb-8" data-id="element-83">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="bg-navy-900 rounded-2xl border border-navy-700 p-6 md:p-8" data-id="element-84">
            {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} data-id="element-85" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};